import React from 'react';
import PropTypes from 'prop-types';

export const PreviewThumbnail = (props) => {
  const {
    ratio,
    thumbnail,
    containerHeight,
    thumbnailMode,
  } = props;
  // To get a fixed height
  const containerWidth = containerHeight * ratio;

  return (
    <div className="thumbnail-preview-container">
      <div
        className="thumbnail-preview"
        style={{
          width: containerWidth,
          height: containerHeight,
          backgroundImage: `url(${thumbnail})`,
          backgroundPosition: 'center',
          // Auto generated thumbnail has the same size with video,
          //  so we use "contain" mode to simulate the padding.
          // Manual select thumbnail otherwise has 2 cases:
          //   1. from MT: with ROI info, doesn't care about bg-size mode;
          //   2. from Image library: without ROI info, use "cover" mode
          //      to simulate the cropping that MT does.
          backgroundSize: thumbnailMode === 'Automatic' ? 'contain' : 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </div>
  );
};

PreviewThumbnail.propTypes = {
  ratio: PropTypes.number.isRequired,
  thumbnail: PropTypes.string,
  thumbnailMode: PropTypes.string.isRequired,
  containerHeight: PropTypes.number.isRequired,
};

PreviewThumbnail.defaultProps = {
  thumbnail: '',
};
